module.exports = __webpack_public_path__ + "img/art3.a873e7b4.png";